interface RichTextChild {
  _type: string
  text?: string
}

interface RichTextBlock {
  _type: string
  children?: RichTextChild[]
}

type RichTextContent = RichTextBlock[]

const extractTextFromRichText = (content: RichTextContent): string => {
  const firstBlock = (content || []).find((block) => block._type === 'block')

  if (!firstBlock) {
    return ''
  }

  const blockContent = (firstBlock.children || [])
    .filter((child) => child._type === 'span')
    .map((span) => span.text || '')
    .join('')

  return blockContent.length > 50
    ? `${blockContent.slice(0, 50).trim()}…`
    : `${blockContent}`
}

export default extractTextFromRichText